module.exports = __webpack_public_path__ + "img/logo.65f0d4b2.png";